import {initialState, USER_SELECTION_STATUS} from '../state';
import {UserClicksElementsActions, UserClicksElementsActionTypes} from '../actions';

export function userSelectionStatus(state = initialState.handelingUserSelectionStatus, action: UserClicksElementsActions): USER_SELECTION_STATUS {
  switch (action.type) {
    case UserClicksElementsActionTypes.UPDATE_USER_SELECTION_STATUS:
      return  action.payload.status;
    default:
      return state;
  }
}
